module.exports = __webpack_public_path__ + "static/media/javascript-intro-hello-world-code.6f8d3006.PNG";